/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_Nav_Go_Home_HintInputs */



/**
* | output |
* | --- |
* | "Go to root (Alt + Home)" |
*
* @param {Spaces_Nav_Go_Home_HintInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_nav_go_home_hint = /** @type {((inputs?: Spaces_Nav_Go_Home_HintInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Nav_Go_Home_HintInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Zum Stammverzeichnis (Alt + Home)")
	return /** @type {LocalizedString} */ ("Go to root (Alt + Home)")
});